import { render, staticRenderFns } from "./carta.vue?vue&type=template&id=cd0e6aec&"
import script from "./carta.vue?vue&type=script&lang=ts&"
export * from "./carta.vue?vue&type=script&lang=ts&"
import style0 from "./carta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports